var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWomanBody(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 365.452,
    y: 407.845,
    transform: "matrix(-0.877 -0.4805 0.4805 -0.877 512.3278 978.8416)",
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.555,
    y: 464.033,
    transform: "matrix(-0.8771 -0.4803 0.4803 -0.8771 427.4801 1069.442)",
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.724,174.4l-5.248-9.264C401.135,127.541,389.91,85.054,389.9,41.824V0h-32v41.824 c0.006,18.187,1.775,36.33,5.28,54.176H159.884c3.993-19.005,6.009-38.372,6.016-57.792V0h-32v38.208 c0,45.384-12.333,89.914-35.68,128.832C59.004,232.801,47.98,311.602,67.644,385.6l34.944,115.008l30.624-9.312L98.428,376.864 c-14.201-54.067-9.995-111.324,11.952-162.736l133.92,66.928C200.076,342.992,181.9,429.008,181.9,512h32 c0-66.64,14.72-281.888,200.368-287.728c13.608,43.34,8.885,90.361-13.072,130.128l-10.8,19.728l28.064,15.376l10.784-19.728 C462.638,308.79,462.063,234.859,427.724,174.4z M265.1,255.728l-140.496-70.256c0.384-0.64,0.672-1.328,1.04-1.952 c10.481-17.529,19.027-36.145,25.488-55.52h220.384c5.889,18.387,13.658,36.118,23.184,52.912l5.248,9.264 c0.496,0.864,0.832,1.824,1.312,2.704C349.531,195.746,300.839,218.22,265.1,255.728z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.9,
    y: 32,
    width: 32,
    height: 32
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanBody);
export default __webpack_public_path__ + "static/media/woman-body.eeba620e5fbbe881190c8cffb59d1f46.svg";
export { ForwardRef as ReactComponent };